import { Character, AbilityName, SkillName, SavingThrowName } from "./types";

export const getAbilityModifier = (score: number): number =>
	Math.floor((score - 10) / 2);

export const getSkillAbility = (skill: SkillName): AbilityName => {
	const skillAbilityMap: Record<SkillName, AbilityName> = {
		acrobatics: "dexterity",
		animalHandling: "wisdom",
		arcana: "intelligence",
		athletics: "strength",
		deception: "charisma",
		history: "intelligence",
		insight: "wisdom",
		intimidation: "charisma",
		investigation: "intelligence",
		medicine: "wisdom",
		nature: "intelligence",
		perception: "wisdom",
		performance: "charisma",
		persuasion: "charisma",
		religion: "intelligence",
		sleightOfHand: "dexterity",
		stealth: "dexterity",
		survival: "wisdom",
	};
	return skillAbilityMap[skill];
};

export const getSkillModifier = (
	character: Character,
	skill: SkillName
): number => {
	const ability = getSkillAbility(skill);
	const abilityMod = getAbilityModifier(character.abilities[ability]);
	const profBonus = character.skills[skill].proficient
		? character.proficiencyBonus
		: 0;
	return abilityMod + profBonus;
};

export const getSavingThrowModifier = (
	character: Character,
	ability: SavingThrowName
): number => {
	const abilityMod = getAbilityModifier(character.abilities[ability]);
	const profBonus = character.savingThrows[ability].proficient
		? character.proficiencyBonus
		: 0;
	return abilityMod + profBonus;
};

export const getPassivePerception = (character: Character): number =>
	10 + getSkillModifier(character, "perception");

export const formatSkillName = (skill: SkillName): string =>
	skill.replace(/([A-Z])/g, " $1").trim();

export const formatAbilityName = (ability: AbilityName): string =>
	ability.charAt(0).toUpperCase() + ability.slice(1);
